export type TPromotionType = {
    colorDescription: string;
    description?: string;
    userSeparation: Record<string, any>;
    imageConfig: Record<string, any>;
    centerDescription: boolean;
    sizeDescription: string | number;
    promoLink?: string;
    dateLeft?: string;
    images: {
        userWebpImage: string;
        guestWebpImage: string;
        userFallbackImage: string;
        guestFallbackImage: string;
    };
}

export type TPromotionGroupType = {
    isEnabled: boolean;
    tagMultiple: string[];
    tag?: string;
    promoLink: string;
    segmentation: Record<string, any>;
    promotions: TPromotionType[];
}

export type TImageBannerProps = {
    item: TPromotionType;
    index: number;
    isHiddenDescription: boolean;
    classNames?: Record<string, string>;
    handleClickOnBanner?: () => void;
}

export type TPromotionProps = {
    item: TPromotionType;
    index: number;
    isHiddenDescription: boolean;
    isReduceDescription: boolean;
    classNames?: Record<string, string>;
    customStyle?: Record<string, string>;
}

export enum VIEW_MODE {
    detailed = 'detailed',
    inline = 'inline',
}

export enum VIEW_ALL_LINK_ACTIONS {
    changeViewMode = 'changeViewMode',
    internalLink = 'internalLink',
    externalLink = 'externalLink',
}

export type TViewModeConfig = {
    viewMode: VIEW_MODE;
    isEnableLink?: boolean;
    linkAction?: VIEW_ALL_LINK_ACTIONS;
    internalLinkUrl?: string;
    externalLinkUrl?: string;
    numberOfElements?: string;
};

export type TPromotionsProps = {
    config: {
        promotionsConfig: {
            promotionsGroup: TPromotionGroupType[];
            viewModeConfig: TViewModeConfig;
            isReduceDescription: boolean;
        };
    };
    isSuppressedDescription?: boolean;
    portletInfo: {
        look: {
            showTitle: boolean;
        };
    };
}
